import { CoralException } from '@ch-types/CoralException';

export default class IhmException extends CoralException {}
